import { render, staticRenderFns } from "./AiCreditsToolTip.vue?vue&type=template&id=506cc6b4&scoped=true"
import script from "./AiCreditsToolTip.vue?vue&type=script&lang=ts"
export * from "./AiCreditsToolTip.vue?vue&type=script&lang=ts"
import style0 from "./AiCreditsToolTip.vue?vue&type=style&index=0&id=506cc6b4&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "506cc6b4",
  null
  
)

export default component.exports